import React, { useState } from 'react';
import { loginUsuario, solicitarAcesso } from '../lib/supabase';
import { Lock, User, Eye, EyeOff } from 'lucide-react';

export default function Login({ onLogin }) {
  const [modo,         setModo]         = useState('login');
  const [usuario,      setUsuario]      = useState('');
  const [senha,        setSenha]        = useState('');
  const [nome,         setNome]         = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [erro,         setErro]         = useState('');
  const [sucesso,      setSucesso]      = useState('');
  const [loading,      setLoading]      = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!usuario || !senha) return setErro('Preencha usuário e senha.');
    setErro(''); setLoading(true);
    try {
      const user = await loginUsuario(usuario.trim(), senha);
      if (!user) return setErro('Usuário ou senha incorretos, ou acesso pendente de aprovação.');
      onLogin(user);
    } catch { setErro('Erro ao conectar. Tente novamente.'); }
    finally { setLoading(false); }
  };

  const handleSolicitar = async (e) => {
    e.preventDefault();
    if (!nome || !usuario || !senha) return setErro('Preencha todos os campos.');
    setErro(''); setLoading(true);
    try {
      await solicitarAcesso(usuario.trim(), senha, nome.trim());
      setSucesso('Solicitação enviada! Aguarde a aprovação do administrador.');
      setModo('login');
      setUsuario(''); setSenha(''); setNome('');
    } catch (err) {
      setErro(err.message?.includes('duplicate') ? 'Esse usuário já existe.' : 'Erro ao solicitar acesso.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#fff',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '20px', fontFamily: "'Inter', 'Segoe UI', sans-serif",
    }}>
      <div style={{
        background: '#0B2341', borderRadius: 24, padding: '40px 36px',
        width: '100%', maxWidth: 420,
        boxShadow: '0 24px 80px rgba(11,35,65,.3)',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src="/logo.jpg" alt="Padrão 67" style={{ width: '100%', maxWidth: 260, borderRadius: 10 }} />
        </div>

        <h2 style={{ fontSize: 18, fontWeight: 700, color: '#fff', marginBottom: 24 }}>
          {modo === 'login' ? 'Entrar no sistema' : 'Solicitar acesso'}
        </h2>

        {erro    && <div style={{ background: 'rgba(239,68,68,.15)', color: '#FCA5A5', border: '1px solid rgba(239,68,68,.3)', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>{erro}</div>}
        {sucesso && <div style={{ background: 'rgba(34,197,94,.15)', color: '#86EFAC', border: '1px solid rgba(34,197,94,.3)', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>{sucesso}</div>}

        <form onSubmit={modo === 'login' ? handleLogin : handleSolicitar}>
          {modo === 'solicitar' && (
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Nome completo</label>
              <div style={{ position: 'relative' }}>
                <User size={15} style={iconStyle} />
                <input value={nome} onChange={e => setNome(e.target.value)} placeholder="Seu nome" style={inputStyle} />
              </div>
            </div>
          )}

          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Usuário</label>
            <div style={{ position: 'relative' }}>
              <User size={15} style={iconStyle} />
              <input value={usuario} onChange={e => setUsuario(e.target.value)} placeholder="Nome de usuário" autoComplete="username" style={inputStyle} />
            </div>
          </div>

          <div style={{ marginBottom: 8 }}>
            <label style={labelStyle}>Senha</label>
            <div style={{ position: 'relative' }}>
              <Lock size={15} style={iconStyle} />
              <input
                type={mostrarSenha ? 'text' : 'password'}
                value={senha} onChange={e => setSenha(e.target.value)}
                placeholder="••••••••" autoComplete="current-password"
                style={{ ...inputStyle, paddingRight: 44 }}
              />
              <button type="button" onClick={() => setMostrarSenha(v => !v)}
                style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'rgba(255,255,255,.4)', display: 'flex' }}>
                {mostrarSenha ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '14px', background: '#F5C400', color: '#0B2341',
            border: 'none', borderRadius: 12, fontSize: 15, fontWeight: 800,
            cursor: loading ? 'not-allowed' : 'pointer', marginTop: 16,
            fontFamily: "'Inter', sans-serif", letterSpacing: '.3px',
            opacity: loading ? .6 : 1, transition: '.15s',
          }}>
            {loading ? 'Aguarde...' : modo === 'login' ? 'Entrar' : 'Solicitar acesso'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 22, fontSize: 13, color: 'rgba(255,255,255,.45)' }}>
          {modo === 'login' ? (
            <span>Não tem acesso?{' '}
              <button onClick={() => { setModo('solicitar'); setErro(''); setSucesso(''); }}
                style={{ background: 'none', border: 'none', color: '#F5C400', fontWeight: 700, cursor: 'pointer' }}>
                Solicitar acesso
              </button>
            </span>
          ) : (
            <button onClick={() => { setModo('login'); setErro(''); setSucesso(''); }}
              style={{ background: 'none', border: 'none', color: '#F5C400', fontWeight: 700, cursor: 'pointer' }}>
              ← Voltar ao login
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

const labelStyle = {
  fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,.5)',
  textTransform: 'uppercase', letterSpacing: '.6px',
  display: 'block', marginBottom: 7,
};

const iconStyle = {
  position: 'absolute', left: 13, top: '50%', transform: 'translateY(-50%)',
  color: 'rgba(255,255,255,.35)', pointerEvents: 'none',
};

const inputStyle = {
  width: '100%', padding: '13px 13px 13px 38px',
  border: '1.5px solid rgba(255,255,255,.12)', borderRadius: 12,
  fontSize: 14, outline: 'none', background: 'rgba(255,255,255,.08)',
  color: '#fff', fontFamily: "'Inter', sans-serif", boxSizing: 'border-box',
};
